import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=27abf96d&scoped=true&"
import script from "./OrderDetail.vue?vue&type=script&lang=js&"
export * from "./OrderDetail.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/order/OrderDetail/OrderDetailStyle.css?vue&type=style&index=0&id=27abf96d&scoped=true&lang=css&"
import style1 from "@@/core/pages/order/OrderDetail/OrderDetailStylePublic.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27abf96d",
  null
  
)

export default component.exports